module.exports = __webpack_public_path__ + "img/clock.d257dcd0.svg";